import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, {
    siteKey: "6LcHkQ4pAAAAAGi2irKaWL6SspLaRATUyOE_UgJB",
    loaderOptions: { useRecaptchaNet: true, autoHideBadge: true }
});